import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const budgetTrackingList = createAsyncThunk("budgetTracking/list", async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + "expense_budget_tracking",
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                premise_id: data?.premise_id,
                year_id: data?.financial_year_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const budgetTracking = createSlice({
    name: "budgetTracking",
    initialState: {
        list: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(budgetTrackingList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
                state.list = null
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = null
            }
        })
    },
})

export default budgetTracking.reducer;